import { useTranslation } from 'react-i18next';
import {
  TouchableHighlight,
  TouchableWithoutFeedback,
  View,
} from 'react-native';
import Color from 'color';
import { COLOR, FONT_SIZE, FONT_WEIGHT } from 'constants/design-system';

import colors from 'config/colors';
import { useGetTimeLabel } from 'modules/Notifications/helpers';
import { PriorityIcon } from 'navigation/components/SideBar/NotificationButton/PriorityIcon';
import { NotificationPriority } from 'store/Notifications/enums';
import { Button, Text } from 'components';
import { BaseButton } from 'components/BaseButton';

type BaseAlertProps = {
  createdAt: string;
  priority?: NotificationPriority;
  title: string;
  message?: string;
  onPress?: () => void;
  onDismiss?: () => void;
};

export const BaseAlert = (props: BaseAlertProps) => {
  const {
    createdAt,
    priority = NotificationPriority.NORMAL,
    title,
    message,
    onPress,
    onDismiss,
  } = props;

  const { t } = useTranslation();

  const getTimeLabel = useGetTimeLabel();
  return (
    <TouchableHighlight
      style={{
        backgroundColor: Color('#3bc3ed').fade(0.8).hexa(),
        paddingHorizontal: 12,
      }}
      underlayColor={Color('#3bc3ed').fade(0.5).hexa()}
      onPress={onPress}
    >
      <View
        style={{
          paddingVertical: 10,
          flexDirection: 'row',
          alignItems: 'flex-start',
        }}
      >
        <View style={{ marginRight: 30, minWidth: 70, gap: 4 }}>
          <View style={{ flexDirection: 'row', gap: 4, alignItems: 'center' }}>
            <PriorityIcon priority={priority} size={32} />
            <Text size={16} font={'bold'} color={colors.text.dark}>
              {title}
            </Text>
          </View>
          <Text color={'#9b9b9b'} size={12}>
            {getTimeLabel(createdAt)}
          </Text>
        </View>
        <View
          style={{
            marginRight: 'auto',
            flexWrap: 'wrap',
            flexGrow: 1,
            flexShrink: 1,
            gap: 4,
            alignItems: 'center',
          }}
        >
          {message && (
            <Text
              color={colors.text.dark}
              numberOfLines={3}
              style={{
                maxWidth: '100%',
              }}
              font="medium"
              size={18}
            >
              {message}
            </Text>
          )}
        </View>

        <View style={{ marginLeft: 30, width: 140 }}>
          <BaseButton
            style={{
              borderRadius: 50,
              paddingVertical: 10,
            }}
            color={COLOR.theme.white}
            backgroundColor={Color(colors.gray).fade(0.3).hexa()}
            onPress={onDismiss}
            fontWeight={FONT_WEIGHT.theme.medium}
            fontSize={FONT_SIZE.theme.sm}
            title={t('notifications.dismiss')}
          />
        </View>
      </View>
    </TouchableHighlight>
  );
};
